/**
 * Local dev config. These values are inlined into the browser bundle, so they
 * must be resolvable from wherever the browser runs -- not from inside the
 * container. Browsing the dev server by machine name (http://anders04:3000)
 * instead of localhost means the API host has to follow, or every request and
 * every SuperTokens redirect still points at the viewer's own machine.
 *
 * VITE_DEV_HOST overrides the host for both; the ports stay fixed (3030 for the
 * API's CORS allowlist, 3000 for the SuperTokens websiteDomain). Unset, this is
 * exactly the previous localhost behaviour.
 */
const host = import.meta.env.VITE_DEV_HOST || 'localhost';

export const LOCAL_CONFIG = {
    apiUrl: `http://${host}:3030`,
    lightningServiceHost: 'ulti-verse.com/lightning',
    url: `http://${host}:3000`,
    // SuperTokens only needs a gateway path when the API sits behind one (prod/test nginx).
    apiGatewayPath: undefined
};
